"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTextSpan = exports.IconCompletionStyles = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Icon_1 = require("../icon/Icon");
const theme_1 = __importDefault(require("../styles/theme"));
const types_1 = require("../../../entities/fact/types");
const IconTextSpanWrapper = styled_1.default.div `
	display: flex;
	align-items: center;

	.icon-text-span_icon {
		display: inline-block;
		border-radius: 50%;
		flex-shrink: 0;
		width: 1.25rem;
		height: 1.25rem;
	}

	.icon-text-span_text {
		padding-left: 10px;
	}

	.icon-text-span_icon-success {
		background-color: ${theme_1.default.colours.success.misc};
	}

	.icon-text-span_icon-error {
		background-color: ${theme_1.default.colours.error.primary};
	}

	.icon-text-span_icon-tip {
		background-color: ${theme_1.default.colours.tip};
	}

	.icon-text-span_icon-primary {
		background-color: ${theme_1.default.colours.primary.primary};
	}

	.icon-text-span_text-error {
		color: ${theme_1.default.colours.error.default};
	}

	.icon-text-span_icon-disabled {
		background-color: ${theme_1.default.palette.greyscale.dark};
	}

	.no-icon {
		display: none;
	}
`;
exports.IconCompletionStyles = {
    [types_1.TaskCompletionState.COMPLETE]: {
        icon: 'check',
        display: 'success'
    },
    [types_1.TaskCompletionState.REVIEW_REQUIRED]: {
        icon: 'ellipses',
        display: 'primary'
    },
    [types_1.TaskCompletionState.INPUT_REQUIRED]: {
        icon: 'exclamation',
        display: 'error'
    },
    [types_1.TaskCompletionState.DISABLED]: {
        icon: 'external',
        display: 'disabled'
    },
    [types_1.TaskCompletionState.HIDDEN]: {
        icon: 'locked',
        display: 'primary'
    }
};
const IconTextSpan = (props) => {
    const { text, icon, className, errorTextColour, noIcon } = props;
    const display = !!props.display ? props.display : 'default';
    const iconClasses = ['icon-text-span_icon', `icon-text-span_icon-${display}`, noIcon ? 'no-icon' : ''].join(' ');
    const textClasses = ['icon-text-span_text', display === 'error' && errorTextColour ? 'icon-text-span_text-error' : ''].join(' ');
    return React.createElement(IconTextSpanWrapper, { className: className },
        React.createElement("span", { className: iconClasses },
            React.createElement(Icon_1.Icon, { icon: icon })),
        React.createElement("span", { className: textClasses }, text));
};
exports.IconTextSpan = IconTextSpan;
//# sourceMappingURL=IconTextSpan.js.map